module.exports = "/wp-content/plugins/farmacy/assets/js/images/strains-indica-49d904faaba895d9a35a0f555f351799.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-thumb/img/strains-indica.png
 ** module id = 160
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 17 22 25 26
 **/